import React from "react";

const TabSwitcher = ({ options, activeTab, handleSwitch }) => {
  return (
    <div className="tab-switcher-wrapper">
      {options.map(
        (sub, i) =>
          sub.active && (
            <button
              key={i}
              className={`p-2 w-full rounded-[6px] text-[12px] transition duration-1000 ease-out transform ${
                activeTab === sub.value
                  ? "bg-neutral-10 text-black"
                  : "text-[#808080]"
              }`}
              value={sub.value}
              onClick={() => {
                handleSwitch(sub.value);
              }}>
              {sub.title}
            </button>
          ),
      )}
    </div>
  );
};

export default TabSwitcher;
